const isDevEnv = process.env.NODE_ENV === 'development';
const isTestEnv = process.env.NODE_ENV === 'test';

const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;
const SERVICE_URL_DEV = process.env.REACT_APP_SERVICE_URL_DEV;
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
const APP_BASE_ROUTE = isTestEnv ? process.env.BASE_URL : process.env.PUBLIC_URL;
const DATE_FORMAT = 'DD-MM-YYYY';
const serviceUrl = isDevEnv ? `http://localhost:3001/api?url=${SERVICE_URL_DEV}` : SERVICE_URL;
// const serviceUrl = isDevEnv ? SERVICE_URL_DEV : SERVICE_URL;

const config = {
  serviceUrl,
  publicUrl: PUBLIC_URL,
  baseRoute: APP_BASE_ROUTE,
  isDevEnv,
  isTestEnv,
  DATE_FORMAT
};

export default config;
